<template>
  <div class="login-container">
    <div class="form-container">
      <Form :model="formInline">
        <FormItem style="text-align: center;">
          <h3>吊车模拟后台管理系统</h3>
        </FormItem>
        <FormItem prop="user">
          <Input type="text" v-model="formInline.user" placeholder="Username">
            <Icon type="ios-person-outline" slot="prepend"></Icon>
          </Input>
        </FormItem>
        <FormItem prop="password">
          <Input type="password" v-model="formInline.password" placeholder="Password">
            <Icon type="ios-lock-outline" slot="prepend" />
          </Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit" style="width: 100%;">登陆</Button>
        </FormItem>
    </Form>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      formInline: {
        user: '',
        password: ''
      }
    }
  },
  methods: {
    handleSubmit() {
      if (! this.formInline.user) {
        this.$Message.error('请输入邮箱');
        return;
      }

      if (! this.formInline.password) {
        this.$Message.error('请输入密码');
        return;
      }

      api.post(api.url('token'), {email: this.formInline.user, password: this.formInline.password}).then(token => {
        token.expired_at = token.expired_at * 1000;
        localStorage.setItem('token', JSON.stringify(token));
        this.$router.push({name: 'index'})
      }).catch(err => {
        this.$Message.error(err);
      })
    }
  }
}
</script>

<style>
  .login-container { display: flex; align-items: center; justify-content: center; height: 100vh; background: url('../assets/bg.png') no-repeat; background-size: 100% 100%; }
  .form-container { width: 380px; padding: 36px; background-color: #fff; border-radius: 8px; }
</style>
